import React, { createContext, useCallback, useContext, useState } from 'react';
import Loader from '../CommonElements/Loader';

const LoaderContext = createContext();

export const useLoader = () => {
    return useContext(LoaderContext);
};

export const LoaderProvider = ({ children }) => {
    const [loading, setLoadingState] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');

    const setLoading = useCallback((value, message = '') => {
        setLoadingState(Boolean(value));
        setLoadingMessage(value ? message || '' : '');
    }, []);

    return (
        <LoaderContext.Provider value={{ loading, setLoading, loadingMessage, setLoadingMessage }}>
            {loading && <Loader message={loadingMessage} />}
            {children}
        </LoaderContext.Provider>
    );
};
